import { DumbAttachment } from "../../../pending-news/DTOs/dumb-news-attachment";
import { DumbMemberNewsArticle } from "./dumb-member-news-article";

export class MemberNewsArticleDetails {
    articleId: number;
    title: string;
    dateString: string;
    contentShortened: string;
    contentFull: string;
    imageUrl: string;
    imageId: string;
    memberId: string;
    memberName: string;
    attachments: DumbAttachment[];
    additionalArticles: DumbMemberNewsArticle[];
}
